import { render } from "./TheHamburger.vue?vue&type=template&id=27a915d2"
import script from "./TheHamburger.vue?vue&type=script&lang=js"
export * from "./TheHamburger.vue?vue&type=script&lang=js"
script.render = render

export default script